// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6595":"c66827a2","7140":"c66827a2","9082":"c66827a2"}[chunkId] + ".chunk.css";
};